import Title from "../components/title";
import React from "react";
import {useTranslation} from "react-i18next";
import Player, {PlayerProps} from "../components/player";
import {useInView} from "react-intersection-observer";
import Subtitle from "../components/subtitle";
import Text from "../components/text";
import Button from "../components/button";

export default function Players() {
    let {t} = useTranslation();

    const {ref, inView} = useInView();

    const players: PlayerProps[] = [{
        name: "Veni",
        iconName: "./players/veni.png",
        twitchName: "Veni",
        youTubeName: "@VeniCraft",
        instagramName: "rafi_veni",
        tiktokName: "venitroll",
        xName: "Venitroll"
    }, {
        "name": "DerBanko",
        "iconName": "./players/derbanko.png",
        "twitchName": "DerBanko",
        "youTubeName": "DerBanko",
        "xName": "DerBanko",
        "tiktokName": "DerBankoo",
        "instagramName": "DerBanko"
    }, {
        name: "Veyla",
        iconName: "./players/veyla.png",
        twitchName: "Veyla",
        youTubeName: "@veylarenee",
        instagramName: "veylarenee",
        tiktokName: "veylareneee",
        xName: "veylarenee"
    }]


    const toBeSorted: PlayerProps[] = [{
        "name": "Spiro639",
        "iconName": "./players/spiro639.png",
        "twitchName": "Spiro639",
        "youTubeName": "Spiro639",
        "tiktokName": "Spiro639",
        "instagramName": "Spiro639"
    }, {
        "name": "LadyNelson",
        "iconName": "./players/ladynelson.png",
        "twitchName": "ladynelsonx3",
        "instagramName": "ladynelsonx3"
    }, {
        "name": "VerdammtDave",
        "iconName": "./players/verdammtdave.png",
        "twitchName": "VerdammtDave",
        "youTubeName": "@VerdammtDave",
        "xName": "VerdammtDave",
        "tiktokName": "verdammtdave",
        "instagramName": "verdammtdave"
    }, {
        "name": "Schmisty",
        "iconName": "./players/schmisty.png",
        "twitchName": "Schmistyy",
        "youTubeName": "Schmisty",
        "xName": "Schmisty",
        "tiktokName": "Schmisty",
        "instagramName": "Schmisty"
    }, {
        "name": "Trinox",
        "iconName": "./players/trinox.png",
        "twitchName": "trinoxde",
        "youTubeName": "trinoxde",
        "xName": "TrinoxDE",
        "tiktokName": "TrinoxDE",
        "instagramName": "TrinoxDE"
    }, {
        "name": "justNoah",
        "iconName": "./players/justnoah.png",
        "twitchName": "justNoahDE",
        "youTubeName": "justNoahDE",
        "xName": "justNoahDE",
        "tiktokName": "@justnoahde",
        "instagramName": "justnoahde"
    }, {
        "name": "MeisterMaki",
        "iconName": "./players/meistermaki.png",
        "twitchName": "MeisterMaki"
    }, {
        "name": "luaks",
        "iconName": "./players/luaks.png",
        "twitchName": "luaks",
        "youTubeName": "@luuuaks",
        "xName": "donluaks",
        "tiktokName": "luuuaks",
        "instagramName": "luuuaks"
    }, {
        "name": "Cornflakes",
        "iconName": "./players/cornflakes.png",
        "twitchName": "cornflakesmcsr",
        "youTubeName": "@Cornflakes267"
    }, {
        "name": "Dimeax",
        "iconName": "./players/dimeax.png",
        "twitchName": "Dimeax",
        "xName": "Dimeax_",
        "instagramName": "Dimeax"
    }, {
        "name": "LucySebast",
        "iconName": "./players/lucysebast.png",
        "twitchName": "LucySebast",
        "youTubeName": "Sebast"
    }, {
        "name": "Vullco",
        "iconName": "./players/vullco.png",
        "twitchName": "vullco",
        "youTubeName": "@vullco",
        "xName": "vullcoo",
        "tiktokName": "vullco",
        "instagramName": "vullco"
    }, {
        "name": "LieberLeo",
        "iconName": "./players/lieberleo.png",
        "twitchName": "lieberleo",
        "tiktokName": "lieberleolive",
        "instagramName": "lieberleolive"
    }, {
        "name": "KrustiBurger",
        "iconName": "./players/krustiburger.png",
        "twitchName": "KrustiBurger",
        "youTubeName": "KrustiBurger",
        "xName": "KrustiBurgerr",
        "tiktokName": "KrustiBurgerr",
        "instagramName": "KrustiBurgerr"
    }, {
        "name": "Quertixxttv",
        "iconName": "./players/quertixxttv.png",
        "twitchName": "Quertixxttv",
        "youTubeName": "@Quertixxttv"
    }, {
        "name": "nurnoco",
        "iconName": "./players/nurnoco.png",
        "twitchName": "nurnoco",
        "youTubeName": "@nurnoco-yt",
        "tiktokName": "nurnoco",
        "instagramName": "nurnoco"
    }, {
        "name": "Space",
        "iconName": "./players/space.png",
        "twitchName": "spaceebtw_",
        "instagramName": "spaceebtw_"
    }, {
        "name": "Flockii",
        "iconName": "./players/flockii.png",
        "twitchName": "zflockii"
    }, {
        "name": "mareq",
        "iconName": "./players/mareq.png",
        "twitchName": "maaareq",
        "youTubeName": "@Mareq",
        "xName": "maaaaareq",
        "tiktokName": "maaareq",
        "instagramName": "maaareq"
    }, {
        "name": "Felikah",
        "iconName": "./players/felikah.png",
        "twitchName": "Felikah",
        "youTubeName": "Felikah",
        "xName": "Feliikah",
        "tiktokName": "Felikah_",
        "instagramName": "Feliikah"
    }, {
        "name": "Sirexpert",
        "iconName": "./players/sirexpert.png",
        "twitchName": "Sirexpert_",
        "youTubeName": "@Sirexpert",
        "xName": "Sirexpert_",
        "tiktokName": "Sirexpert_",
        "instagramName": "Sirexpert"
    }, {
        "name": "ZweiMPeter",
        "iconName": "./players/zweimpeter.png",
        "twitchName": "ZweiMPeter",
        "youTubeName": "@ZweiMPeter",
        "xName": "peteramglas",
        "tiktokName": "zweimpeter",
        "instagramName": "zweimpeter"
    }, {
        "name": "DerLiber",
        "iconName": "./players/derliber.png",
        "twitchName": "DerLiber",
        "youTubeName": "@DerLiber",
        "xName": "DerLiberLive"
    }, {
        "name": "Z_nicoTV",
        "iconName": "./players/z_nicotv.png",
        "twitchName": "Z_nicoTV",
        "tiktokName": "zNicoTV",
        "instagramName": "zNicoTV"
    }, {
        "name": "Lunarie",
        "iconName": "./players/lunarie.png",
        "twitchName": "Lunarie_ttv",
        "youTubeName": "@Lunarie_ttv",
        "xName": "Lunarie_ttv",
        "tiktokName": "Lunarie_ttv",
        "instagramName": "Lunarie_reels"
    }, {
        "name": "bySeli",
        "iconName": "./players/byseli.png",
        "twitchName": "bySeli",
        "youTubeName": "@bySeli",
        "xName": "byselii",
        "tiktokName": "byseli",
        "instagramName": "byyseli"
    }, {
        "name": "ZaveryTV",
        "iconName": "./players/zaverytv.png",
        "twitchName": "ZaveryTV",
        "tiktokName": "ZaveryTV",
        "instagramName": "ZaveryTV"
    }, {
        "name": "Urutox",
        "iconName": "./players/urutox.png",
        "twitchName": "Urutox",
        "youTubeName": "@Urutox",
        "xName": "Urutox",
        "tiktokName": "Urutox",
        "instagramName": "Urutox"
    }, {
        "name": "Wettermann",
        "iconName": "./players/wettermann.png",
        "twitchName": "Wettermann_",
        "youTubeName": "@Wettermannn",
        "xName": "Wettermann_",
        "tiktokName": "Wettermann_",
        "instagramName": "Wettermann_"
    }, {
        "name": "linastunna",
        "iconName": "./players/linastunna.png",
        "twitchName": "linastunna",
        "youTubeName": "@linastunna",
        "xName": "linastunna",
        "tiktokName": "linastunna",
        "instagramName": "linastunna"
    }, {
        "name": "exnfachjan",
        "iconName": "./players/exnfachjan.png",
        "twitchName": "exnfachjan",
        "youTubeName": "exnfachjan",
        "xName": "exnfachjan",
        "tiktokName": "exnfachjan",
        "instagramName": "exnfachjan"
    }, {
        "name": "Kedos",
        "iconName": "./players/kedos.png",
        "twitchName": "kedos",
        "youTubeName": "kedos",
        "xName": "thekedoszone",
        "tiktokName": "kedos_",
        "instagramName": "kedos"
    }, {
        "name": "Minooo99_",
        "iconName": "./players/minooo99_.png",
        "twitchName": "minooo99_",
        "youTubeName": "@MinoooGAMES",
        "tiktokName": "minooo991",
        "instagramName": "minooo99_"
    }, {
        "name": "glowKathi",
        "iconName": "./players/glowkathi.png",
        "twitchName": "glowkathi",
        "tiktokName": "glowkathi",
        "instagramName": "glow_kathi"
    }, {
        "name": "Lerokes",
        "iconName": "./players/lerokes.png",
        "twitchName": "lerokes"
    }, {
        "name": "Finnitzko",
        "iconName": "./players/finnitzko.png",
        "twitchName": "Finnitzko",
        "youTubeName": "@Finnitzko",
        "xName": "Finnitzko",
        "tiktokName": "Finnitzko"
    }, {
        "name": "MaxeyTV",
        "iconName": "./players/maxeytv.png",
        "twitchName": "letsmaxeytv",
        "youTubeName": "@LetsMaxeyTV",
        "tiktokName": "maxeytv",
        "instagramName": "maxi._nbg"
    }, {
        "name": "J3NOX",
        "iconName": "./players/j3nox.png",
        "twitchName": "J3N0X",
        "instagramName": "J3N0X"
    }, {
        "name": "Jasko5",
        "iconName": "./players/jasko5.png",
        "twitchName": "Jasko5",
        "youTubeName": "@Jasko5fünf",
        "instagramName": "Jasko5_"
    }, {
        "name": "FrozenNoah",
        "iconName": "./players/frozennoah.png",
        "twitchName": "fr0zennoah",
        "youTubeName": "@FrozenNoah",
        "xName": "frozennoahat",
        "tiktokName": "frozennoahat",
        "instagramName": "noah_dbm"
    }, {
        "name": "Clayten",
        "iconName": "./players/clayten.png",
        "twitchName": "Clayten",
        "youTubeName": "@Clayten",
        "xName": "ClaytenYT",
        "tiktokName": "clay_minecraft",
        "instagramName": "clayten.yt"
    }, {
        "name": "huytastic",
        "iconName": "./players/huytastic.png",
        "twitchName": "huytastic"
    }, {
        "name": "vace",
        "iconName": "./players/vace.png",
        "twitchName": "icyvace",
        "youTubeName": "@icyvacelive",
        "xName": "icyvace",
        "tiktokName": "icyvace",
        "instagramName": "icyvace"
    }, {
        "name": "Faister",
        "iconName": "./players/faister.png",
        "twitchName": "Faister",
        "youTubeName": "@Faister",
        "xName": "Faisterino",
        "tiktokName": "faisterr",
        "instagramName": "faistergram"
    }, {
        "name": "nooreax",
        "iconName": "./players/nooreax.png",
        "twitchName": "nooreax",
        "youTubeName": "@nooreax",
        "xName": "nooreaxYT",
        "tiktokName": "nooreax",
        "instagramName": "nooreax"
    }, {
        "name": "LetsHugo",
        "iconName": "./players/letshugo.png",
        "twitchName": "LetsHugoTV",
        "youTubeName": "@LetsHugo",
        "xName": "LetsHugoYT",
        "tiktokName": "letshugotv",
        "instagramName": "letshugo"
    }, {
        "name": "Wichtiger",
        "iconName": "./players/wichtiger.png",
        "twitchName": "Wichtiger",
        "youTubeName": "Wichtiger",
        "xName": "WichtigerYT",
        "tiktokName": "mikewichtiger",
        "instagramName": "wichtigermike"
    }, {
        "name": "BastiGHG",
        "iconName": "./players/bastighg.png",
        "twitchName": "BastiGHG",
        "youTubeName": "kompetenzGHG",
        "xName": "kompetenzGHG",
        "instagramName": "babaesti"
    }, {
        "name": "Jonsman",
        "iconName": "./players/jonsman.png",
        "twitchName": "Jonsman",
        "youTubeName": "@derkleinespatz",
        "xName": "thejonsman",
        "instagramName": "jonasmoche"
    }, {
        "name": "Tjan",
        "iconName": "./players/tjan.png",
        "twitchName": "Tjan",
        "youTubeName": "@Tjan",
        "xName": "TjanTV",
        "tiktokName": "tjantv",
        "instagramName": "tjantv"
    }, {
        "name": "CastCrafter",
        "iconName": "./players/castcrafter.png",
        "twitchName": "CastCrafter",
        "youTubeName": "CastCrafter",
        "xName": "CastCrafter",
        "tiktokName": "CastCrafter",
        "instagramName": "Castagram_"
    }, {
        "name": "Fuxel",
        "iconName": "./players/fuxel.png",
        "twitchName": "Fuxelbau",
        "youTubeName": "@Fuxel",
        "xName": "Fuxelbau",
        "instagramName": "fuxelbau"
    }];

    for (const prop of toBeSorted.sort((a, b) => a.name.localeCompare(b.name))) {
        players.push(prop);
    }

    const slideAnimation = (inView: boolean) => {
        return "transition-slide ease-in-out duration-1000 delay-100 "
            + (inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[-4rem]");
    };

    return (
        <div ref={ref} className="flex flex-col gap-7">
            <Title id={"players"} title={t("players.title")}/>
            <div
                className="grid grid-cols-5 max-[1510px]:grid-cols-4 max-[1050px]:grid-cols-3 max-[750px]:grid-cols-2 max-[450px]:grid-cols-1 gap-10 items-center">
                {players.map((player, index) =>
                    <Player player={player} index={index} inView={inView} key={index}/>)}
            </div>
            {/*<div className={"flex flex-col gap-2 " + slideAnimation(inView)}>
                <Subtitle>{t("players.apply.title")}</Subtitle>
                <Text>{t("players.apply.text")}</Text>
                <div className="flex max-[800px]:flex-col justify-center max-[800px]:gap-0 gap-3">
                    <Button link="https://www.discord.gg/gTEPvAYFEA" newTab={true}>{t("players.apply.button")}</Button>
                </div>
            </div>*/}

            {/**<div className="mx-auto">
             <Title title={t("players.to-be-announced")}/>
             </div>**/}
        </div>
    );
}